exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".coordinate-input-container{width:100%;margin:0!important}.coordinate-input-container input{margin:3px!important;border-radius:4px!important;min-width:0}.show-bbox input,.show-point input{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/src/views/filters/AreaFilterView.css
// module id = 2002
// module chunks = 0